import { Injectable } from "@angular/core";
import { AbstractService } from "./abstract.service";
import { HttpClient } from "@angular/common/http";
import { CondominioResponseDto } from "../dto/condominio-response.dto";
import { firstValueFrom } from "rxjs";

@Injectable({ providedIn: 'root' })
export class CondominioService extends AbstractService {
    private readonly url = this.API_REST + '/condominios';

    constructor(http: HttpClient) { super(http) }

    async getByCode(code: string): Promise<CondominioResponseDto | null> {
        const response$ = this.http.get<{ items: CondominioResponseDto[] }>(this.url + `/${code}`);
        const data = await firstValueFrom(response$);
        return data.items.length > 0 ? data.items[0] : null
    }
}